









































































import { Component, Prop, Vue, Watch, Ref } from "vue-property-decorator";
import { storeDokter } from "@/store/modules/dokter";
import http from "@/axios/http-common";

@Component({
  components: {},
})
export default class AutoCompleteTindakan extends Vue {
  @Prop() register!: string;
  @Prop() dokterDefault: object;
  @Prop() unit_id: string;
  @Prop() index: number;
  @Prop() autofocus: boolean;
  @Prop() disabled: boolean;
  @Prop() tindakan = {
    pemeriksaan_id: null,
    pelayanan: null,
    jumlah: null,
    tarif: null,
    dokter: null,
    c_doc_id: null,
    subtotal: null,
  };
  @Ref() readonly jml;
  validasi = [(v) => this.cek(v) || this.message()];
  msg = "";

  listTindakan = [];
  searchString = null;
  _timerId;

  get listDokter() {
    return storeDokter.listAll;
  }

  removeItem() {
    this.$emit("removeItem");
  }
  count() {
    this.tindakan.subtotal = this.tindakan.jumlah * Number(this.tindakan.tarif);
    this.$emit("count");
  }
  changeDokter(val) {
    this.tindakan.c_doc_id = val.c_doc_id;
  }
  changeTindakan(val) {
    if (val) {
      this.tindakan.pemeriksaan_id = val["id"];
      this.tindakan.jumlah = 1;
      this.tindakan.tarif = val["tarif"];
      this.tindakan.subtotal = val["tarif"];
      if (val.dokter) {
        this.tindakan.dokter = val.dokter;
        this.tindakan.c_doc_id = val.dokter.c_doc_id;
      } else {
        this.tindakan.dokter = this.dokterDefault;
        this.tindakan.c_doc_id = this.dokterDefault["c_doc_id"];
      }
      this.count();
      this.$emit("selectedItem", {
        tindakan: this.tindakan,
        index: this.index,
      });
      this.$nextTick(() => {
        this.jml.focus();
      });
    }
  }

  @Watch("searchString")
  searched() {
    this.listTindakan = [];
    clearTimeout(this._timerId);
    this._timerId = setTimeout(() => {
      if (this.searchString === null || this.searchString.length < 2) return;
      this.searchTindakan(this.searchString);
    }, 500);
  }
  searchTindakan(termSearch) {
    http
      .getDataParam(`/billing/unit/${this.unit_id}/pelayanan`, {
        params: { term: termSearch, register_id: this.register },
      })
      .then((res) => {
        this.listTindakan = res.data.data;
      })
      .finally();
  }
  enter() {
    this.$emit("addTindakan");
  }

  cek(v) {
    if (this.tindakan.jumlah != null) {
      if (this.tindakan.jumlah.length > 2)
        this.tindakan.jumlah = this.tindakan.jumlah.substring(
          0,
          this.tindakan.jumlah.length - 1
        );
    }

    if (Number(v) > 10) {
      this.msg = "Yakin diisi " + v + " ?";
      return false;
    } else return true;
  }

  message() {
    return this.msg;
  }
}
